﻿import { Plugin } from 'ckeditor5';
import { Dialog, ButtonView, IframeView, InputTextView } from 'ckeditor5';

// #module-Subscriber
const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <g transform="matrix(2,0,0,2,0,0)">
        <path d="M24,12a1,1,0,0,0-1-1h-.83a.26.26,0,0,1-.25-.22,10,10,0,0,0-8.7-8.71A.24.24,0,0,1,13,1.83V1a1,1,0,0,0-2,0v.83a.24.24,0,0,1-.22.24,10,10,0,0,0-8.7,8.71.26.26,0,0,1-.25.22H1a1,1,0,0,0,0,2h.83a.26.26,0,0,1,.25.22,10,10,0,0,0,8.7,8.7.26.26,0,0,1,.22.25V23a1,1,0,0,0,2,0v-.83a.26.26,0,0,1,.22-.25,10,10,0,0,0,8.7-8.7.26.26,0,0,1,.25-.22H23A1,1,0,0,0,24,12ZM13.25,19.89a.18.18,0,0,1-.17-.05.21.21,0,0,1-.08-.16V19.5a1,1,0,0,0-2,0v.14a.25.25,0,0,1-.09.19.24.24,0,0,1-.2.06,8,8,0,0,1-6.6-6.6.24.24,0,0,1,.06-.2A.22.22,0,0,1,4.36,13H4.5a1,1,0,0,0,0-2H4.36a.22.22,0,0,1-.19-.09.24.24,0,0,1-.06-.2,8,8,0,0,1,6.6-6.6.24.24,0,0,1,.2.06.22.22,0,0,1,.09.19V4.5a1,1,0,0,0,2,0V4.28a.17.17,0,0,1,.07-.14.19.19,0,0,1,.15,0,8,8,0,0,1,6.67,6.61.24.24,0,0,1-.06.2.22.22,0,0,1-.19.09H19.5a1,1,0,0,0,0,2h.25a.17.17,0,0,1,.12.05.2.2,0,0,1,0,.13A8,8,0,0,1,13.25,19.89Z"></path>
        <circle cx="12" cy="9.5" r="3"></circle>
        <path d="M12,13.5a5.75,5.75,0,0,0-4.94,2.81.45.45,0,0,0,0,.46.47.47,0,0,0,.41.23h9a.47.47,0,0,0,.41-.23.45.45,0,0,0,0-.46A5.75,5.75,0,0,0,12,13.5Z"></path>
    </g>
</svg>`;

class PlaceholderChooser extends Plugin {
    static get pluginName() { return "PlaceholderChooser" };

    // Make sure the "Dialog" plugin is loaded.
    get requires() {
        return [Dialog, IframeView];
    }

    init() {
        const editor = this.editor;
        const dialog = editor.plugins.get('Dialog');
        const { t } = editor.locale;

        // Add a button to the component factory so it is available for the editor.
        editor.ui.componentFactory.add('placeholderChooser', locale => {

            const icon = new ButtonView(locale);
            icon.set({
                label: t('Choose placeholder'),
                withText: false,
                icon: svg,
                tooltip: t('Choose placeholder')
            });

            // Define the button behavior on press.
            icon.on('execute', () => {

                const frameView = new IframeView(locale);

                frameView.set({
                    label: t('Choose placeholder'),
                    tooltip: true,
                    withText: false
                });

                // render the frameView to get an element to apply styles
                frameView.render();

                frameView.element.style.width = '550px';
                frameView.element.style.height = '650px';
                frameView.element.style.margin = '5px 15px';

                frameView.element.removeAttribute('sandbox');

                // build url for iframe
                let path = location.href.toLowerCase();
                let isTextcomponent = path.indexOf('/textcomponent/') >= 0;
                let addCulture = path.indexOf('edittemplatedefaultvalues.aspx?') === -1 || isTextcomponent;

                let isFormEditor = path.indexOf('formeditor/content/edit') > -1 || // form content editor
                    path.indexOf('eventforms/content/edit') > -1 || // event form content editor
                    path.indexOf('/forms/createedit/') > -1 ||      // basic form options (description, closed registration)
                    path.indexOf('/eventforms/createedit/') > -1;   // basic event form options (description, closed registration)

                let isCampaignEditor = path.indexOf("campaigneditor/") > -1 ||
                    path.indexOf("/campaigns/editor") > -1 ||
                    path.indexOf("/campaigns/content/") > -1;

                let isEventlayoutEditor = path.indexOf('/eventlayouts/editor') > -1;

                let allowEventsInForms =
                    path.indexOf('formeditor/content/edit') > -1 || // form content editor
                    path.indexOf('eventforms/content/edit') > -1 || // event form content editor
                    path.indexOf('formeditor/action/edit') > -1 || // form action editor
                    path.indexOf('eventforms/action/edit') > -1; // event form action editor

                let params = new URLSearchParams();
                params.append('customEventId', 'PlaceholderChooserPlugin_InsertPlaceholder');

                if (isFormEditor || isEventlayoutEditor) {
                    params.append('hideForms', 'true');
                }

                if (allowEventsInForms) {
                    var guids = window.location.href.match(/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i);
                    if (guids && guids.length > 0) {
                        params.append('openerFormId', guids[0]);
                    }
                }

                if (isTextcomponent) {
                    params.append('hideTextComponents', 'true');
                }

                if (typeof cultureToUse !== 'undefined' && addCulture) {
                    params.append('cultureId', cultureToUse);
                }

                if (isCampaignEditor) {
                    let queryParams = new URLSearchParams(window.location.search);
                    var campaignId = queryParams.get("Guid");
                    if (campaignId) {
                        params.append('campaignId', campaignId);
                    }
                }

                frameView.element.src = `/Dynamix/App#/Controls/PlaceholderChooser?${params.toString()}`;

                function blockBlur(eventInfo) {
                    eventInfo.stop();
                }

                function addPlaceholder(evt) {
                    editor.execute('input', { text: evt.detail.placeholder });
                    dialog.hide();
                    editor.editing.view.focus();
                }

                // block/stop blur event to avoid closing campaign editor when switching tabs in placeholder chooser
                editor.on('blur', blockBlur, { priority: 'highest' });

                // handle placeholder selection
                window.addEventListener('PlaceholderChooserPlugin_InsertPlaceholder', addPlaceholder);

                // "dummy" textbox to set focus to (to avoid focus on close button)
                let focusElement = new InputTextView();
                focusElement.set({ tabIndex: -1, withText: false, id: 'hidden-focus-element' });

                dialog.show({
                    isModal: true,
                    title: t('Choose placeholder'),
                    content: [
                        focusElement,
                        frameView
                    ],
                    className: 'placeholder-chooser-dialog',
                    onHide() {
                        // unregister events when closing the dialog
                        editor.off('blur', blockBlur);
                        window.removeEventListener('PlaceholderChooserPlugin_InsertPlaceholder', addPlaceholder);
                    }
                });
            });

            return icon;
        });
    }
}

export default PlaceholderChooser;